<template>
  <van-nav-bar
    title="地址列表"
    left-text="返回"
    left-arrow
    @click-left="$router.go(-1)"
  />
  <div class="address_content">
    <van-address-list
      v-model="chosenAddressId"
      :list="addressList"
      :disabled-list="disabledAddressList"

      default-tag-text="默认"
      @add="AddAddress"
      @edit="EditAddress"
    />
  </div>
</template>
<script>
import axios from "../../commons/AxiosMethod.js"

export default {
  name: "header",
  data () {
    return {
      chosenAddressId: "", // 选中的地址ID
      addressList: [], // 地址集合
      disabledAddressList: [] // 超出配送距离地址集合
    }
  },
  props: {
    AttributeGroup: {}
  },
  components: {},
  mounted () {
    this.GetAddress()
  },
  methods: {
    // 新增地址
    AddAddress () {
      this.$router.push({
        name: "addressedit",
        query: {
          id: "add"
        }
      })
    },
    // 编辑地址
    EditAddress (item, index) {
      this.$router.push({
        name: "addressedit",
        query: {
          id: item.id
        }
      })
    },
    // 获取地址
    GetAddress (item) {
      axios.apiMethod(
        "/api/User/GetUserAddress",
        "get",
        {},
        (result) => {
          if (result.Code == 200) {
            this.addressList = []
            result.Data.forEach((element) => {
              this.addressList.push({
                id: element.Id,
                name: element.Name,
                tel: element.Phone,
                address: element.DetailedAddress,
                isDefault: element.Default,
                isDefault: element.Default
              })
            })
          } else {
            showToast(result.Msg)
          }
        },
        (e) => {}
      )
    }

  }
}
</script>
<style  lang="scss"  scoped>
</style>
